export const currentMembers = [
  {
    name: 'Agnieszka Janiuk',
    role: 'Professor, Group Leader',
    image: '/img/AstroGrupa_people/Agnieszka_sm.jpg',
    link: 'https://www.cft.edu.pl/pages/agnieszka-janiuk/',
    snippet: 'Agnieszka leads the astrophysics research group at CTP PAS since 2011. Her research focuses on gamma ray bursts, black hole accretion, and relativistic MHD simulations. She received full professorship in 2021.',
    bio: [
      'Agnieszka Janiuk was born and grew up in Warsaw. She studied astronomy at the Physics Department of the Warsaw University, where she received her Master of Science degree in 1998. After that, she continued her research via PhD program at Nicolaus Copernicus Astronomical Center, working on modeling and observations of accretion processes in AGN and Galactic black hole X-ray binaries. She developed the GLADIS numerical code for simulating unstable accretion disk evolution.',
      'In 2003 she was a fellow at Max Planck Institute for Astrophysics in Garching, Germany. Her second postdoctoral fellowship was at the University of Nevada, Las Vegas, USA. In 2010, she moved to join the faculty of the Center for Theoretical Physics of PAS. In January 2021, she was awarded the full professorship by the President of Poland.',
      'Her current research is devoted to gamma ray bursts — ultra-relativistic jets launched at the cost of black hole rotation and accretion mediated by strong magnetic fields. The theoretical research utilizes fully General Relativistic multi-dimensional simulations of accretion and magnetized jet ejections.'
    ]
  },
  {
    name: 'Joseph Saji',
    role: 'PhD Student',
    image: '/img/AstroGrupa_people/joseph_s.JPG',
    snippet: 'Joseph holds a Master\'s degree from Cochin University of Science and Technology, India. He works on modeling kilonova emission under the supervision of Prof. Janiuk since October 2023.',
    bio: [
      'Joseph is a passionate astrophysics PhD student with a Master\'s degree in Physics from Cochin University of Science and Technology, Kerala, India. He worked as a research assistant at IISER-TVM on observational GRB research. His master\'s thesis focused on X-ray flares in GRB afterglows.',
      'He has been working with the CFT astrophysics group since October 2023, focusing on modeling of kilonova emission. His interests beyond physics include travel, music, and reading.'
    ]
  },
  {
    name: 'Pulkit Ojha',
    role: 'PhD Student',
    image: '/img/AstroGrupa_people/pulkit.jpeg',
    snippet: 'Pulkit completed his Integrated Masters in Physics from NISER, India. He studies radiation pressure instabilities in neutron star X-ray binaries using the GLADIS code.',
    bio: [
      'Pulkit joined CTP PAS as a doctoral student under Prof. Janiuk. He completed his Integrated Masters in Physics from NISER, India, and carried out his master\'s thesis on spin evolution of millisecond pulsars under Prof. Sudip Bhattacharyya from TIFR, Mumbai.',
      'At CTP, he works with the GLADIS code to study radiation pressure instabilities in the inner edge of accretion disks of neutron stars in X-ray binaries.'
    ]
  },
  {
    name: 'Piotr Płonka',
    role: 'PhD Student',
    image: '/img/AstroGrupa_people/pplonka.jpg',
    snippet: 'Piotr studied astronomy at the University of Warsaw. His research focuses on GRMHD simulations of jet formation and propagation, and developing numerical codes.',
    bio: [
      'Piotr was born and grew up in southern Poland. He studied astronomy at the University of Warsaw, completing his bachelor\'s and master\'s degrees. His master\'s thesis investigated relativistic jets in collapsing stars under the supervision of Prof. Janiuk.',
      'After completing his master\'s, he remained in the Astrophysics Group for a PhD program starting October 2025. His research focuses on GRMHD simulations of jet formation and propagation, as well as developing numerical codes.'
    ]
  },
  {
    name: 'Łukasz Klepczarek',
    role: 'Technical Staff',
    image: '/img/AstroGrupa_people/Lukz.jpg',
    snippet: 'Łukasz obtained his PhD studying spectra of Seyfert galaxies and black-hole binaries. He works on software engineering of the HARM code since July 2024.',
    bio: [
      'Łukasz studied physics at the University of Łódź and obtained his PhD under the supervision of prof. Andrzej Niedźwiecki. His PhD thesis focused on the spectra of Seyfert galaxies and black-hole binaries in the context of relativistic reflection from accretion disks.',
      'Since July 2024, he works with prof. Agnieszka Janiuk on software engineering of the HARM code.'
    ]
  },
];

export const formerMembers = [
  {
    name: 'Gerardo Urrutia Sanchez',
    role: 'Former Postdoc (2023–2025)',
    current: 'Postdoc at UC Santa Cruz',
    image: '/img/AstroGrupa_people/Gerardo_dp.jpg',
  },
  {
    name: 'Fatemeh Hossein-Nouri',
    role: 'Former Postdoc',
    current: 'Postdoc at INFN, Milan, Italy',
    image: '/img/AstroGrupa_people/Fatemeh_sm.jpg',
  },
  {
    name: 'Bestin James',
    role: 'Former PhD Student',
    current: 'Postdoc at Masaryk University Brno, Czechia',
    image: '/img/AstroGrupa_people/bestin.jpeg',
  },
  {
    name: 'Przemysław Figura',
    role: 'Former Postdoc',
    current: '',
    image: '/img/AstroGrupa_people/avatar.png',
  },
  {
    name: 'Mikołaj Grzędzieslki',
    role: 'Former PhD Student (2013–2018)',
    current: 'Data Scientist at Bank Pekao S.A.',
    image: '/img/AstroGrupa_people/Mikolaj.png',
  },
  {
    name: 'Ishika Palit',
    role: 'Former PhD Student (2017–2021)',
    current: 'Postdoc at National Tsing Hua University',
    image: '/img/AstroGrupa_people/ishika.jpeg',
  },
  {
    name: 'Petra Sukova',
    role: 'Former Postdoc (2013–2016)',
    current: 'Staff Scientist at ASU CAS, Prague',
    image: '/img/AstroGrupa_people/petra-sukova.jpg',
  },
];

export const otherFormerMembers = [
  'Bartłomiej Kamiński',
  'Jeremy Mortier',
  'Szymon Charzyński',
  'Kostas Sapountzis — Postdoc',
  'Dominika Król',
];
